module.exports = __webpack_public_path__ + "img/turfy2_fuji@2x.29469bab.png";